"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _contact_element_item = _interopRequireDefault(require("hbars!../../scripts/templates/contact_element_item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContactsElementRenderView = _backbone.default.View.extend({
  getContactsToDisplay: function getContactsToDisplay() {
    var auto = this.model.get('auto');
    var isEdit = this.model.get('isEdit');
    var contacts = this.model.get('contacts') || [];

    if (contacts && auto) {
      contacts = contacts.slice(0, this.model.get('count'));
    }

    var entities = this.model.get('entities');

    if (entities && entities.toJSON) {
      entities = entities.toJSON();
    }

    return isEdit ? contacts : entities;
  },
  render: function render() {
    var contactsToDisplay = this.getContactsToDisplay();

    var data = _objectSpread(_objectSpread({}, this.model.toJSON()), {}, {
      contacts: contactsToDisplay
    });

    this.$el.html((0, _contact_element_item.default)(data));
    return this;
  }
});

var _default = ContactsElementRenderView;
exports.default = _default;